import React, { useContext, useState } from "react";
import { PageLayout } from "../components/page-layout";
import { SiteVarsContext } from "../contexts/sitevars-context";
import { useSiteVarsFunctions } from "../hooks/use-site-vars-functions";
import { setUpdateWeekResource } from "../services/update-week.service";
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TextField, Button, Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export const UpdateWeekPage = () => {
  const {siteVarsData, refreshSiteVars} = useContext(SiteVarsContext);
  const { formatGameWeek } = useSiteVarsFunctions();
  const [currentWeekValue, setCurrentWeekValue] = useState(siteVarsData.game_vars.currentWeek);
  const formattedWeek = formatGameWeek(); // Example usage
  const [newWeekValue, setNewWeekValue] = useState("");
  const [validationError, setValidationError] = useState("");
  const [siteVarsUpdating, setSiteVarsUpdating] = useState(false);
  
  const handleSetUpdateWeek = async () => {
    if (validationError) {
      return;
    }
    setSiteVarsUpdating(true);
    
    await setUpdateWeekResource();

    setSiteVarsUpdating(false);
    refreshSiteVars();
  };

  const handleUpdateTextField = (event) => {
    const value = event.target.value;
    setNewWeekValue(value);

    const parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue) || parsedValue !== parseInt(currentWeekValue, 10) + 1) {
      setValidationError("New week must be exactly 1 greater than current week.");
    } else {
      setValidationError("");
    }
  };

  return (
    <PageLayout>
      <TableContainer component={Paper}>
      {currentWeekValue === 0 && (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width={"100%"} height={30} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
        </Stack>
      )}
      {currentWeekValue > 0 && (
      <Table sx={{ minWidth: 390 }} size="small">
        <TableBody>
          <TableRow>
            <TableCell align="right">Current week:</TableCell>
            <TableCell>{currentWeekValue}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="right">New week:</TableCell>
            <TableCell>  
              <TextField
                id="new-week"
                onChange={handleUpdateTextField}
                variant="standard"
                size="small"
                value={newWeekValue}
                error={!!validationError}
                helperText={validationError}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      )}
      
    </TableContainer>

    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
    <Button
      sx={{ marginTop: "10px", marginRight:"10px" }}
      disabled={siteVarsUpdating || !!validationError}
      onClick={handleSetUpdateWeek}
      variant="contained"
    >
      Update
    </Button>
</Box>
    </PageLayout>
  );
};
